import { form as formEs, result as resultEs, optionsTexts as optionsTextsEs } from './es';
import { form as formPt, result as resultPt, optionsTexts as optionsTextsPt } from './pt';

export const pt = {
  form: formPt,
  optionsTexts: optionsTextsPt,
  result: resultPt,
};

export const es = {
  form: formEs,
  optionsTexts: optionsTextsEs,
  result: resultEs,
};

